function createColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    const minRange = 130;
    const colorRange = 280 - minRange;
    const mixUp1 = Math.abs(hash * hash / 3);
    const mixUp2 = Math.abs(hash * hash / 5);
    const mixUp3 = Math.abs(hash * hash / 7);
    return `hsl(${minRange + (mixUp1 % colorRange)}, ${30 + (mixUp2 % 40)}%, ${30 + (mixUp3 % 50)}%)`;
}
function createColorDarkMode(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
    }
    const minRange = 5;
    const colorRange = 55 - minRange;
    const mixUp1 = Math.abs(hash * hash / 3);
    const mixUp2 = Math.abs(hash * hash / 5);
    const mixUp3 = Math.abs(hash * hash / 7);
    return `hsl(${minRange + (mixUp1 % colorRange)}, ${30 + (mixUp2 % 40)}%, ${30 + (mixUp3 % 50)}%)`;
}
/**
 * Get a color for the given document type. This is the external function called,
 * so that we can swap the effekt easily.
 * @returns The colors #
 * @param value
 */
export function getColorForString(value) {
    if (document.documentElement.getAttribute("class")?.includes("dark")) {
        return createColorDarkMode(value || '');
    }
    else {
        return createColor(value || '');
    }
}
